import React, { useState } from 'react';
import DataSourceValueList from './DataSourcesValue/DataSourceValueList';
import { DetailRadioList } from '../../../pages/events/components/EventDetailsControls';
import Input from 'components/common/Input/FormInput';

const SYSTEM_DATA = 'System Data';
const CUSTOM_LIST = 'Custom List';

const SOURCE_TYPE = {
    [SYSTEM_DATA]: 'dynamic',
    [CUSTOM_LIST]: 'static',
};

function SingleSelectDetail(props) {
    const [option, setOption] = useState(props.values.option);

    let title = 'Selectable Options';
    if (option === CUSTOM_LIST) {
        title += ' - one option per line';
    }

    const ListTypeComponent = getListType(option, props);
    return (
        <div data-cy="SingleSelectDetail">
            <DetailRadioList
                name={`detail-radio-list-${props.id}`}
                title={title}
                options={[CUSTOM_LIST, SYSTEM_DATA]}
                onSelect={value => {
                    setOption(value);
                    props.onItemChanged(props.values.id, 'option', value);
                    props.onItemChanged(props.values.id, 'sourceType', SOURCE_TYPE[value]);
                }}
                value={option}
                disableOtherOption={true}
                selectedOption={option}
            />

            <ListTypeComponent {...props} />
        </div>
    );

    function getListType(option) {
        let listType;

        switch (option) {
            case CUSTOM_LIST:
                listType = CustomList;
                break;
            case SYSTEM_DATA:
                listType = DataSourceValueList;
                break;
            default:
                listType = () => <div></div>;
        }

        return listType;
    }
}

function CustomList(props) {
    const [text, setText] = useState(props.values.staticText);

    const onTextChanged = (e) => {
        const text = e.target.value;
        setText(text);
        props.onItemChanged(props.values.id, 'staticText', text);

        let options = null;
        if (text) {
            options = text.split('\n');
        }

        props.onItemChanged(props.values.id, 'options', options);
    };

    const isValid = () => { 
        return text && text.length !== 0;
    };

    return (
        <Input
            title={'Custom Options'}
            placeholder={'Type to add options'}
            type={'textarea'}
            isValid={isValid}
            required={true}
            value={text}
            onBlur={onTextChanged}
            onChange={onTextChanged}
            data-cy="SingleSelectDetail-Custom"
        />
    );
}

export default SingleSelectDetail;
